export const messages = [
    'Setting up a secure connection',
    'Getting your portfolio details',
    'Calculating your credit limit',
    'Please wait, we’re almost there',
];

export const dots = ['.', '..', '...'];

export enum PollarStatus {
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
    IN_PROGRESS = "IN_PROGRESS",
}
